import * as FileSaver from 'file-saver';
import XLSX from 'sheetjs-style';
import { Button, Tooltip } from 'antd';

export default function ExportExcel({ excelData, fileName, buttonSize = 'medium', buttonText = 'Export Excel' }) {
    const fileType = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    const fileExtension = '.xlsx';
    const exportToExcel = async fileName => {
        const ws = XLSX.utils.json_to_sheet(excelData);
        const wb = { Sheets: { data: ws }, SheetNames: ['data'] };
        const excelBuffer = XLSX.write(wb, { bookType: 'xlsx', type: 'array' });
        const data = new Blob([excelBuffer], { type: fileType });
        FileSaver.saveAs(data, fileName + fileExtension);
    };

    return (
        <>
            <Tooltip>
                <Button
                    type="primary"
                    onClick={() => exportToExcel(fileName)}
                    style={{
                        marginRight: '10px',
                    }}
                    size={buttonSize}
                >
                    {buttonText}
                </Button>
            </Tooltip>
        </>
    );
}
